'use client';

import { useRefreshGVKey } from '@/hooks/query/use-streaming-data';
import { useStreamingStore } from '@/store/streaming';
import { StreamingBase } from '../streaming-base';
import { MatchModelBase } from '@nf/types/odds';

export const GameVisualization = ({ match }: { match?: MatchModelBase }) => {
	const [
		streamingSrc,
		channelList,
		setStreamingUrl
	] = useStreamingStore(
		state => [
			state.streamingSrc,
			state.channelList,
			state.setStreamingUrl
		]
	);
	const { data, refetch } = useRefreshGVKey();
	//這裡只拿到key，後面怎麼產生的還要看一下套件
	return <StreamingBase match={match} />;
};

